import { ManuteRequestConfig } from '@/api/types';
import { PasswordResetRequest } from '@/api/requests/types';

const PASSWORD_RESETS_BASE_URL = '/password';

/**
 * Find reset request by token
 * @param token
 */
export const FIND = (token: string): ManuteRequestConfig => ({
    method: 'GET',
    url: `${PASSWORD_RESETS_BASE_URL}/find/${token}`,
    requiresAuth: false,
});

/**
 * Request to create token for password change
 */
export const CREATE = (email: string): ManuteRequestConfig => ({
    method: 'POST',
    url: `${PASSWORD_RESETS_BASE_URL}/create`,
    data: email,
    requiresAuth: false,
});

/**
 * Reset existing password
 * @param companyId
 * @param company
 */
export const RESET = (request: PasswordResetRequest): ManuteRequestConfig => ({
    method: 'POST',
    url: `${PASSWORD_RESETS_BASE_URL}/reset`,
    data: request,
    requiresAuth: false,
});
